// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5481":"0445e491","8726":"dd8922b8"}[chunkId] + ".chunk.css";
};